// Milestone constants for consistent usage across the application
export const MILESTONE_NAMES = {
    // Transaction Milestones
    DEAL_DETAILS: 'Deal Details',
    COMPLIANCE_CHECK: 'Compliance Check',
    VESSEL_CHECK: 'Vessel Check',
    CREDIT_APPROVAL: 'Credit Approval',
    SUPPLIER_CREDIT_CHECK: 'Supplier Credit Check',
    DEAL_CONFIRMATION: 'Deal Confirmation',
    DEAL_FINANCING_CONFIRMATION: 'Deal Financing Confirmation',
    PURCHASE_ORDER: '129knots Purchase Order',
    SALES_ORDER: '129knots Sales Order',
    ADD_ON_SERVICES: 'Add On Services',
    DELIVERY_TRACKING: 'Delivery Tracking',
    BDN: 'BDN',
    SUPPLIER_INVOICE: 'Supplier Invoice',
    BUYER_INVOICE: 'Buyer Invoice',
    SUPPLIER_PAYMENT: 'Supplier Payment',
    BUYER_PAYMENT: 'Buyer Payment',
    DEAL_CLOSED: 'Deal Closed',

    // RFQ Milestones
    RFQ_CREATED: 'RFQ Created',
    RFQ_PUBLISHED: 'RFQ Published',
    BID_SUBMITTED: 'Bid Submitted',
    BID_ACCEPTED: 'Bid Accepted',
    BID_REJECTED: 'Bid Rejected',

    // Payment Status
    PAYMENT_PENDING: 'Pending',
    PAYMENT_PARTIALLY_PAID: 'Partially Paid',
    PAYMENT_CORRECTED: 'Corrected',
    PAYMENT_CLOSED: 'Closed',
    PAYMENT_SUCCESSFUL: 'Successful',
    PAYMENT_ACTIVE: 'Active',

    // Transaction Status
    TRANSACTION_ACTIVE: 'Active',
    TRANSACTION_COMPLETED: 'Completed',
    TRANSACTION_CANCELLED: 'Cancelled',
    TRANSACTION_PENDING: 'Pending'
};

// Milestone types for backend processing
export const MILESTONE_TYPES = {
    DEAL_DETAILS: 'deal_details',
    COMPLIANCE_CHECK: 'compliance_check',
    VESSEL_CHECK: 'vessel_check',
    CREDIT_APPROVAL: 'credit_approval',
    SUPPLIER_CREDIT_CHECK: 'supplier_credit_check',
    DEAL_CONFIRMATION: 'deal_confirmation',
    DEAL_FINANCING_CONFIRMATION: 'deal_financing_confirmation',
    PURCHASE_ORDER: '129knots_purchase_order',
    SALES_ORDER: '129knots_sales_order',
    ADD_ON_SERVICES: 'add_on_services',
    DELIVERY_TRACKING: 'delivery_tracking',
    BDN: 'BDN',
    SUPPLIER_INVOICE: 'supplier_invoice',
    BUYER_INVOICE: 'buyer_invoice',
    SUPPLIER_PAYMENT: 'supplier_payment',
    BUYER_PAYMENT: 'buyer_payment',
    DEAL_CLOSED: 'deal_closed',

};

// Payment milestone types
export const PAYMENT_MILESTONES = {
    SUPPLIER: MILESTONE_TYPES.SUPPLIER_PAYMENT,
    BUYER: MILESTONE_TYPES.BUYER_PAYMENT
};

// Document upload constants
export const DOCUMENT_CONSTANTS = {
    MAX_DOCUMENTS_PER_PAYMENT: 3,
    MAX_DOCUMENTS_PER_DEAL_FINANCING: 5, // For deal financing forms / delivery tracking
    MAX_FILE_SIZE_MB: 10,
    ALLOWED_FILE_TYPES: ['.pdf', '.jpeg', '.jpg', '.png'],
    MAX_FILE_SIZE_BYTES: 10 * 1024 * 1024 // 10MB in bytes
};

// transaction_documents.document_type values
export const TRANSACTION_DOCUMENT_TYPES = {
    DELIVERY_TRACKING: 'delivery_tracking', // legacy
    DELIVERY_TRACKING_BUYER: 'delivery_tracking_buyer', // legacy
    DELIVERY_TRACKING_SUPPLIER: 'delivery_tracking_supplier', // legacy
    SATELLITE_DATA: 'satellite_data', // legacy
    ARTIFACT: 'delivery_tracking_artifact',
    ADDITIONAL_DOCUMENTS: 'delivery_tracking_additional',
};

export const DELIVERY_TRACKING_DOCUMENTS_TOOLTIP =
    'A maximum of 5 Documents are allowed to be uploaded in Artifact and Additional Documents sections and becomes read-only after saving.';

export const SKIP_MILESTONE_DETAILS = {
    SKIP_PO_EVENT: "Purchase Order",
    SKIP_PO_DESCRIPTION: "As part of the Invoice Financing process, the Purchase Order (PO) upload or generation was skipped.",
    SKIP_PO_NOTIFICATION: "Purchase Order milestone skipped successfully",
    SKIP_SO_EVENT: "Sales Order",
    SKIP_SO_DESCRIPTION: "As part of the Invoice Financing process, the Sales Order (SO) upload or generation was skipped.",
    SKIP_SO_NOTIFICATION: "Sales Order milestone skipped successfully"
}

// A cancelled transaction is read-only for all roles: disable visible action
// buttons, form fields, and uploads when this returns true. Do not change
// existing show/hide logic or Next button behavior.
export const isTransactionReadOnly = (status) =>
    String(status || '').toLowerCase() === 'cancelled';